import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print-label',
  templateUrl: './print-label.component.html',
  styleUrls: ['./print-label.component.scss']
})
export class PrintLabelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
